//import { helpers } from '../helpers.js';

var newsletter = {
  options: {
    "ajax_url": sikmoVars.ajax_url,
		"doing_ajax": false,
  },

  selectors: {
    // global selectors
		"input_email": ".js-newsletter-input-email",
		"submit_button": ".js-newsletter-submit-button",
		"success_message": ".js-newsletter-success-message",
		"form": ".js-newsletter-form",
  },

  init: function () {
    const self = this;

    jQuery(self.selectors.submit_button).on('click', function (e) {
      e.preventDefault();
      self.sendAjax();
    });
  },

  sendAjax: function () {
    const self = this;

		const email = jQuery(self.selectors.input_email).val();

		if (!self.options.doing_ajax) {
			self.options.doing_ajax = true;
			jQuery(self.selectors.submit_button).attr('disabled', 'disabled');

			jQuery.ajax({
				url: self.options.ajax_url,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'subscribe_newsletter',
					email: email,
				},
				success: function (response) {
					if (response.data.status === 'success') {
						jQuery(self.selectors.success_message).show();
						jQuery(self.selectors.form).hide();
					} else {
						alert(response.data.message);
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					if (jqXHR.responseJSON.data.status == 'error') {
						alert(jqXHR.responseJSON.data.message);
					}
				},
				complete: function () {
					self.options.doing_ajax = false;
					jQuery(self.selectors.submit_button).removeAttr('disabled');
				}
			});
		}
  }
}

// Export
export { newsletter };